/**
 * Tope de duración de videos (20 min, todos los módulos). El backend es la
 * validación autoritativa (`backend/src/utils/videoDuration.js`); esto solo
 * avisa antes de gastar datos móviles subiendo un archivo que será rechazado.
 * Fail-open: si el navegador no puede leer la duración, se deja subir.
 */

export const MAX_VIDEO_SECONDS = 20 * 60;

const TOLERANCIA_SEGUNDOS = 1;

export function formatDuracion(seconds: number): string {
  const total = Math.round(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}

/** Duración en segundos, o null si el navegador no la pudo leer (≤ 5 s). */
export function getVideoDurationSeconds(file: File): Promise<number | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    let listo = false;
    const terminar = (valor: number | null) => {
      if (listo) return;
      listo = true;
      window.clearTimeout(timer);
      URL.revokeObjectURL(url);
      video.removeAttribute("src");
      video.load();
      resolve(valor);
    };
    const timer = window.setTimeout(() => terminar(null), 5000);
    video.preload = "metadata";
    video.onloadedmetadata = () =>
      terminar(Number.isFinite(video.duration) ? video.duration : null);
    video.onerror = () => terminar(null);
    video.src = url;
  });
}

/**
 * Devuelve el mensaje de error si `file` es un video de más de 20 min;
 * `null` si no es video, no excede o no se pudo medir.
 */
export async function mensajeVideoDemasiadoLargo(file: File): Promise<string | null> {
  if (!file.type?.startsWith("video/")) return null;
  const seconds = await getVideoDurationSeconds(file);
  if (seconds === null || seconds <= MAX_VIDEO_SECONDS + TOLERANCIA_SEGUNDOS) return null;
  return `El video "${file.name}" dura ${formatDuracion(seconds)} y el máximo permitido es ${
    MAX_VIDEO_SECONDS / 60
  } minutos. Recórtalo o súbelo en partes.`;
}
